import { render, staticRenderFns } from "./HitoricoEventoDlg.vue?vue&type=template&id=b2faa5a4"
import script from "./HitoricoEventoDlg.vue?vue&type=script&lang=js"
export * from "./HitoricoEventoDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports